import { getModalViewState } from '../store/Store';
import { mutatorAction } from 'satcheljs';

/**
 * Action which sets the current isShown in the state based on the input
 * @param isShown the new value for isShown
 */
export const toggleModalViewState = mutatorAction('changeIsShown', () => {
    getModalViewState().isShown = !getModalViewState().isShown;
});
